import { render, staticRenderFns } from "./AddCreditsModal.vue?vue&type=template&id=72953e85&"
import script from "./AddCreditsModal.vue?vue&type=script&lang=js&"
export * from "./AddCreditsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports